var map = {
	"./contact.png": "ce8b",
	"./demande.png": "793f",
	"./devis.png": "790e",
	"./espacePatient.png": "460c",
	"./galeri.png": "c68d",
	"./home.png": "094e",
	"./message.png": "4ed0",
	"./question.png": "8ca1",
	"./result.png": "6222",
	"./services.png": "5a66",
	"./siteweb.png": "355c",
	"./tools1.png": "3bed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31d9";